import langData from './langData';

const defaultLang = 'is';
const storageKey = 'currentLang';

export default {
	collect: false,
	
	setCurrentLang: function(lang) {
		window.currentLang = lang;

		try {
			localStorage.setItem(storageKey, lang);
			} catch (e) {
			console.warn('Could not save language to localStorage', e);
		}

		if (window.eventBus) {
			window.eventBus.dispatch('Lang.languageChanged');
		}
	},

	get: function(phrase) {
		if (window.traceLangGet) {
			console.log('Lang.get: '+phrase);
		}

		if (!window.currentLang) {
			// window.currentLang = defaultLang;
			try {
				const stored = localStorage.getItem(storageKey);
				window.currentLang = stored || defaultLang;
			} catch (e) {
				window.currentLang = defaultLang;
			}
		}

		if (!langData[window.currentLang]) {
			window.currentLang = defaultLang;
		}

		if (this.collect) {
			if (!this.notFound) {
				this.notFound = [];
			}

			if (!langData[window.currentLang][phrase]) {
				if (this.notFound.indexOf(phrase) === -1) {
					this.notFound.push(phrase);
					console.log('Did not find translation for "'+phrase+'"');
				}
			}
		}

		return !langData[window.currentLang] || !langData[window.currentLang][phrase] ? phrase : langData[window.currentLang][phrase];
	}
};


// WEBPACK FOOTER //
// ./src/lang/Lang.js